import styled from "styled-components";


export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
`;


export const Header = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;

`;


export const Title = styled.div`
  font-size: 2rem;
  margin: 2rem;
`;

export const RemoveAll = styled.div`
  width: 4rem;
`
